import * as Tone from 'tone';
import AudioEffect from '../effects/audio/AudioEffect';
import AudioChain from './AudioChain';
import AutomationManager from './AutomationManager';
import LiveState from './LiveState';
import Track from './Track';
class GroupTrack {
    constructor() {
        this.tracks = [];
        this.output = new Tone.Gain(0, "decibels");
        this.chain = new AudioChain();
        this.automationManager = new AutomationManager();
        this.output.connect(LiveState.Master.input);
        this.volume = this.output.gain;
        this.automationManager.makeAutomatable('Mixer', 'Volume', this.output.gain);
        this.chain.output().connect(this.output);
        this.input = this.chain.input();
    }
    fire(slot) {
        for (const track of this.tracks) {
            track.slot(slot).fire();
        }
    }
    stop() {
        for (const track of this.tracks) {
            track.stop();
        }
    }
    insert(object, position) {
        if (Array.isArray(object)) {
            for (const obj of object) {
                this.insert(obj);
            }
            return this;
        }
        if (object instanceof Track) {
            if (this.tracks.indexOf(object) === -1) {
                this.tracks.push(object);
                object.output().disconnect();
                object.output().connect(this.chain.input());
            }
        }
        else if (object instanceof AudioEffect) {
            this.chain.insert(object, position);
        }
        else {
            throw Error('Incompatible object inserted into GroupTrack');
        }
        return this;
    }
}
export default GroupTrack;
//# sourceMappingURL=GroupTrack.js.map